import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];
const VIEW = { once: true, amount: 0.15 };

export const Reveal = ({ children, delay = 0, y = 36, className = "", as = "div", ...rest }) => {
  const C = motion[as];
  return (
    <C
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={VIEW}
      transition={{ duration: 0.9, ease: EASE, delay }}
      {...rest}
    >
      {children}
    </C>
  );
};

const lineV = {
  hidden: { y: "110%" },
  show: (i) => ({ y: "0%", transition: { duration: 1.05, ease: EASE, delay: i * 0.09 } }),
};

export const MaskLines = ({ lines, className = "", lineClassName = "", onLoad = false, baseDelay = 0 }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    {...(onLoad ? { animate: "show" } : { whileInView: "show", viewport: VIEW })}
  >
    {lines.map((l, i) => (
      <span key={i} className="block overflow-visible pb-[0.16em]">
        <motion.span className={`block leading-[1.15] ${lineClassName}`} variants={lineV} custom={i + baseDelay}>
          {l}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

export const Eyebrow = ({ children, dark = false, num }) => (
  <p className={`flex items-center gap-3 font-mono text-xs uppercase tracking-[0.22em] ${dark ? "text-orange" : "text-orange-deep"}`}>
    {num && <span className={dark ? "text-slate-300" : "text-slate-500"}>{num}</span>}
    <span className="h-px w-8 bg-current" />
    {children}
  </p>
);
